/*
 * Decléor — Collection tabs: arrows beside the pills
 * ---------------------------------------------------------------------------
 * Moves the carousel's prev/next buttons out of the carousel and into the tab row, so the pills and
 * the two arrows read as one centred cluster instead of a centred pill group with two buttons pinned
 * to the page edges. The layout itself is CSS (sections/section-collection-tabs.liquid); this file
 * only relocates two nodes.
 *
 * WHY THIS CANNOT BE DONE IN CSS ALONE. Flickity builds its buttons INSIDE the carousel element, and
 * the carousel sits in .tab-content, a different subtree from .tab__scroll where the pills live. No
 * selector can lay out a box relative to a sibling's content width, so there is nothing to position
 * the arrows against. Moving the nodes is the whole trick — and it is safe, because a DOM listener
 * travels with its element: Flickity binds its click handler to the button itself, so the button keeps
 * driving its carousel after the move.
 *
 * ONE PAIR OF ARROWS PER TAB, WHICH IS THE REAL WORK HERE. Every .tab-content has its own carousel and
 * therefore its own buttons. Move tab 0's pair into the shared row and it would still be driving tab 0
 * after the visitor switches to tab 2 — the arrows would look right and do nothing. So the pair is
 * re-placed on every tab change, reading the .current pane the theme marks.
 *
 * OPT-IN, via data-tabs-arrows-inline emitted by the section. The same section also renders inside the
 * header's mega-menu dropdown, which has its own cramped layout and no business being re-arranged.
 *
 * FLICKITY MAY NOT HAVE BUILT THE BUTTONS YET on first pass, so the initial placement is retried a few
 * times and then given up on. Failing to place them leaves the page exactly as it is today: the CSS is
 * gated on data-tabs-arrows-ready, which only this file sets.
 *
 * ES5 on purpose: every custom script in assets/ is a classic deferred IIFE with no build step.
 */
(function () {
  'use strict';

  var FLAG = 'data-tabs-arrows-inline';
  var READY = 'data-tabs-arrows-ready';
  var BOUND = 'data-tabs-arrows-bound';

  function restore(row) {
    var moved = row.querySelectorAll('.flickity-button');
    var i;
    var btn;
    for (i = moved.length - 1; i >= 0; i -= 1) {
      btn = moved[i];
      if (btn._dcTabsHome) {
        btn._dcTabsHome.appendChild(btn);
      }
    }
  }

  function place(section) {
    var row = section.querySelector('.tab__scroll');
    var tabs = row ? row.querySelector('.tabs') : null;
    if (!(row && tabs)) {
      return false;
    }

    var pane =
      section.querySelector('.tab-content.current') ||
      section.querySelector('.tab-content');
    if (!pane) {
      return false;
    }

    var prev = pane.querySelector('.flickity-button.previous');
    var next = pane.querySelector('.flickity-button.next');
    if (!(prev && next)) {
      return false;
    }

    /* SEND BACK WHATEVER IS ALREADY HERE FIRST. Without this the row accumulates: switching tab put the
       new pane's pair in next to the pills while the previous pane's pair stayed, so the row grew by one
       button on each side per switch — measured, the prev arrow slid from x=447 to x=395 on the first
       change. Each button remembers the element it came from, so it goes home rather than being dropped:
       a button removed from its carousel is a control its own tab can never get back. */
    restore(row);

    /* insertBefore / appendChild MOVE the node when it already has a parent, which is what we want —
       no clone, so the handler Flickity bound to it comes along. */
    prev._dcTabsHome = prev.parentNode;
    next._dcTabsHome = next.parentNode;
    row.insertBefore(prev, tabs);
    row.appendChild(next);
    row.setAttribute(READY, '');
    return true;
  }

  function bind(section) {
    if (section.hasAttribute(BOUND)) {
      return;
    }
    section.setAttribute(BOUND, '');

    section.addEventListener('click', function (event) {
      if (!event.target.closest) {
        return;
      }
      if (event.target.closest('.tab-link')) {
        /* The theme moves `current` on the panes; wait for that before reading it. */
        window.requestAnimationFrame(function () {
          place(section);
        });
      }
    });
  }

  function boot(scope) {
    var root = document;
    if (scope && scope.querySelectorAll) {
      root = scope;
    }
    var nodes = root.querySelectorAll('[' + FLAG + ']');
    var i;
    var placed = 0;
    for (i = 0; i < nodes.length; i += 1) {
      bind(nodes[i]);
      if (place(nodes[i])) {
        placed += 1;
      }
    }
    return { total: nodes.length, placed: placed };
  }

  function bootWithRetries() {
    var tries = 0;
    function attempt() {
      var r = boot(document);
      tries += 1;
      if (r.placed < r.total && tries < 12) {
        window.setTimeout(attempt, 250);
      }
    }
    attempt();
  }

  bootWithRetries();

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
